import React, { Component } from 'react'
import { MDBCard, MDBCardBody, MDBCardTitle, MDBCardText, MDBCardHeader, MDBBtn, MDBContainer, MDBCardFooter } from "mdbreact";
import { MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavbarToggler, MDBCollapse, MDBNavItem, MDBNavLink, MDBIcon } from 'mdbreact';

export default class TimeLine extends Component {
  render() {
    return (
        	<div class="container">

		<div class="row timeline_intro">
			<div class="col"></div>
			<div class="col-12 col-sm-12 col-md-10 col-lg-9 col-xl-8">
				<p class="timeline_brief">For the next six months of the study, we are asking you to focus on one initial month of tracking (POWER28!) and 5 monthly POWER Weeks.</p>
			</div>
			<div class="col"></div>
		</div>

		<div class="row justify-content-center">
			<div class="col-12 col-sm-12 col-md-8 col-lg-7 col-xl-7">
				<img class="timeline_length" src="https://i.ibb.co/s5tLNSS/slice64-3x.png" alt="slice64-3x" border="0"/>
			</div>
			<div class="col-auto">
				<p class="timeline_brief">6 Months</p>
			</div>
		</div>

		<div class="row timeline_components justify-content-center">
			<div class="col-auto">
				<img class="timeline_componentsA" src="https://i.ibb.co/FKJTpZJ/slice45-3x.png" alt="slice45-3x" border="0"/>
			</div>
			<div class="col-auto">
				<img class="timeline_componentsB" src="https://i.ibb.co/ZVyvqmP/slice47-3x.png" alt="slice47-3x" border="0"/>
			</div>
		</div>

		<div class="row">
			<div class="col"></div>
			<div class="col-10 col-sm-9 col-md-8 col-lg-7 col-xl-6">
                <MDBNavLink class="nav-link" to="/power28">
				   <a href="#"  class="Bottom_button">
				   <p>What is a Power28?</p>
				   </a>
                </MDBNavLink>
            </div>
			<div class="col"></div>
		</div>

	</div>
);
  }
}





// WEBPACK FOOTER //
// ./src/components/TimeLine.js